import {IRouteDefinition, IRouteDefinitionParams} from "../../../index";
import {createErrorMessage} from "../../../util/misc";
import {Abstract} from "./Abstract";
import {getRouteButton, getRouteDefinition} from "../../../constants/RouteDefinitions";
import {NO_COMMENT} from "../../../constants/Language";
import {ButtonManager} from "../../../util/ButtonManager";
import detailsHtml from './details.html?raw';

export let template: string = detailsHtml;

export class viewModel extends Abstract {
    private NO_COMMENT = NO_COMMENT
    private customerconfig: IRouteDefinition | null;
    private readonly headingButtons = new ButtonManager([
        getRouteButton('editcustomercomments', {
            cssClass: 'action',
            showLabel: true,
        }),
    ]);

    constructor(params: IRouteDefinitionParams) {
        super(params);
        this.customerconfig = getRouteDefinition('customerconfig');
    }

    protected override initRequest(): Promise<void> {
        return super.initRequest()
            .then(() => {
                this.messageData(null);
                this.isReady(true);
            })
            .catch((reason: string) => this.messageData(createErrorMessage(String(reason))));
    }
}
